import React, { useContext } from 'react';
import { HeaderContext } from '@context/HeaderContext';

const HeaderNavi = () => {
    const { headerMenu, subMenu } = useContext(HeaderContext);

    return (
      <>
      <div className="sub-tit-bg">
        <div className="container sub-h">
          <div className="sub-tit-01">
            <img src="/img/ico-home.png" alt="home" />
  
            {headerMenu && <>{headerMenu}</>}
  
            {headerMenu && subMenu && <> {'|'} {subMenu}</>}
  
          </div>
        </div>
      </div>
        </>
      );
    };

export default HeaderNavi;
